export const priceFilter = () => {
	const priceMin = document.getElementById('min_price');
	const priceMax = document.getElementById('max_price');
	const priceFilter = document.getElementById('price-filter');
	const priceSlider = document.getElementById('price-slider');
	
	if(priceSlider) {
		priceMin.addEventListener('input', function(e) {
			priceFilter.submit();
		});
	}
	
	if(priceMax) {
		priceMax.addEventListener('input', function(e) {
			priceFilter.submit();
		});
	}
	
	jQuery( document ).ready(function($) {
		$( ".price_slider" ).on( "slidechange", function( event, ui ) {
			$('#price-filter').submit();
		} );
	});
}


